import { css } from "@emotion/react";
import { Link } from "react-router-dom";

const Schedule: React.FC = () => {
  return (
    <div css={mainStyle} id="schedule">
      <div css={staffContentsWrapperStyle}>
        <div css={contentsWrapper}>
          <div css={upperTitleWrapperStyle}>
            <div css={borderStyle}></div>
            <div css={titleStyle}>スケジュール</div>
            <div css={borderStyle}></div>
          </div>
          <img
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/schedule.png"}
            alt="schedule"
            css={imgStyle}
          />
          <div css={bottomBorderWrapperStyle}>
            <div css={borderStyle}></div>
          </div>
        </div>
      </div>
      <div css={routerButtonStyle}>
        <Link to="/schedule" css={linkStyle}>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/route-to-schedule.png"
            }
            alt="キャスト出演スケジュール"
            width="220"
          />
        </Link>
      </div>
      <div css={bottomSpaceStyle}></div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
`;

const staffContentsWrapperStyle = css`
  background-color: rgba(255, 255, 255);
  display: flex;
  justify-content: center;
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 30px 20px 40px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const bottomBorderWrapperStyle = css`
  padding-top: 10px;
  display: flex;
  align-items: center;
`;
const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const imgStyle = css`
  width: 220px;
  margin-top: 30px;
`;

const routerButtonStyle = css`
  padding: 30px 0;
  display: flex;
  justify-content: center;
`;

const bottomSpaceStyle = css`
  width: 100%;
  height: 20px;
  background-color: #fff;
`;

const linkStyle = css`
  height: 24.15px;
`;

export default Schedule;
